import React from 'react';
import { useParams } from 'react-router-dom';
import { TypedMemo } from '../../common/types';
import { LoadingView } from '../../common/views/LoadingView';
import { useAccountId } from '../../../redux/slices/appInfo/hooks';
import { SocialScreen } from './SocialScreen';

/** A post id of the path, or undefined when the path holds none or a bad one. */
export function socialPostIdOf(id: string | undefined): number | undefined {
  if (id === undefined || !/^\d+$/.test(id)) {
    return undefined;
  }
  return Number(id);
}

/**
 * The Social routes: `/social` and `/social/post/:id` (design your-intelligence h4). Every call is
 * account-scoped.
 */
const SocialViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const { id } = useParams<{ id?: string }>();

  if (accountId === null) {
    return <LoadingView />;
  }

  return <SocialScreen accountId={accountId} openPostId={socialPostIdOf(id)} />;
};

export const SocialView = TypedMemo(SocialViewComponent);
